import { useContext } from "react";
import InfoContext from "../../context/InfoContext";

export function useInfo() {
    const { setInfo } = useContext(InfoContext);
    return function info(message, type = 'success') {
        setInfo({ type, show: true, message });
        setTimeout(() => setInfo({ show: false, message: '' }), 6000);
    }
}